<template>
  <draft v-model="active" :route="route" />
</template>

<script>
import draft from "@/views/components/order/draft/draft.vue";
export default {
  components: {
    draft,
  },
  data() {
    return {
      active: "/asg/draft", //当前激活页
      route: {
        order: "/asg/order",
        draft: "/asg/draft",
      }
    };
  }
};
</script>
